var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14 1.5H4A2.5 2.5 0 0 0 1.5 4v10A2.5 2.5 0 0 0 4 16.5h10a2.5 2.5 0 0 0 2.5-2.5V4A2.5 2.5 0 0 0 14 1.5ZM4 0a4 4 0 0 0-4 4v10a4 4 0 0 0 4 4h10a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4H4Z",
    clipRule: "evenodd",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.778 13a.764.764 0 0 1-.391-.108A.806.806 0 0 1 6 12.2V5.8c0-.286.148-.548.387-.692a.755.755 0 0 1 .776-.002l5.444 3.2A.803.803 0 0 1 13 9c0 .286-.15.552-.393.694l-5.444 3.2a.766.766 0 0 1-.385.106Z",
    fill: "currentColor",
    className: "accent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.d85b073161f7e6461e52b298a8c32b1a.svg";
export { ForwardRef as ReactComponent };